import { Output, EventEmitter, ViewChild, Injector, ElementRef, OnInit } from '@angular/core';
import { ComponentBase } from './component-base';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormSchemaItem } from '../form-schema';
import { ValidationSummaryComponent } from '../../components/validation-summary/validation-summary.component';
import { NotifierService } from '../../services/notifier.service';
import { BaseService } from '../../services/base.service';
import { Dialog } from 'primeng/dialog';
import { CommonService } from '../../services/common.service';
import { FileUpload } from 'primeng/primeng';
import { CONFIG_CALENDAR_VIETNAMESE } from '../../../config/calendar.config';
import { VsMySettingService } from '../../../services/ccmysetting.service';
import { VsMySetting } from '../../../models/ccmysetting';
import { DetailAddress } from '../../models/detailAddress.model';

export class SecondPageEditBase extends ComponentBase implements OnInit {

    @ViewChild('validationSummary') validationSummary: ValidationSummaryComponent;
    @ViewChild('dialog') dialog: Dialog;
    @ViewChild('formElement') formElement: ElementRef;
    @ViewChild('pUpload') pUpload: FileUpload;

    vi = CONFIG_CALENDAR_VIETNAMESE;
    isShow = false;
    submitting = false;
    openPopupDelete = false;

    itemDetail: any = {};
    formSchema: FormSchemaItem[] = [];
    uploadedFiles: any[] = [];

    popupHeader = '';
    popupId: string;
    formGroup: FormGroup = new FormGroup({});
    limitSize: number;

    limitAll = 10000;

    protected _mySettingService: VsMySettingService;

    arrTrangThai = [
        { label: 'Sử dụng', value: 1 },
        { label: 'Không Sử dụng', value: 2 }
    ];

    @Output() closePopup = new EventEmitter<any>();
    mySetting = new VsMySetting();

    constructor(
        protected _baseService: BaseService,
        protected _injector: Injector,

    ) {
        super();
        this._mySettingService = this._injector.get(VsMySettingService);
        this._notifierService = this._injector.get(NotifierService);
        this.popupId = this._injector.get(CommonService).guid();
        this.mySetting = this._mySettingService.getCurrentSetting();

        // this._masterDataService.getConfigByCode('SizeOfFile')
        //     .then(response => {
        //         if (response) {
        //             this.limitSize = Number(response) * 1000 * 1000;
        //         }
        //     });
    }

    ngOnInit(): void {
        // this._masterDataService.getConfigByCode('SizeOfFile')
        //     .then(response => {
        //         if (response) {
        //             this.limitSize = Number(response) * 1000 * 1000;
        //         }
        //     });
    }

    splitYearMonth = (s: any): { year: number; month: number } | null => {
        if (typeof s !== 'string') return null;

        const parts = s.split('-');
        if (parts.length !== 2) return null;

        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);

        if (isNaN(year) || isNaN(month) || month < 1 || month > 12) return null;

        return { year, month };
    };

    save() {
        this.submitting = true;

        if (this.formGroup.invalid) {
            this.validationSummary.showValidationSummary();
            this.showValidateMessage();
            this.submitting = false;
            this.scrollToTop();
            return;
        }

        this.onBeforeSave();

        if (this.itemDetail['id']) {
            this.onUpdate();
        } else {
            this.onInsert();
        }
    }

    showValidateMessage() {

    }

    onBeforeSave() {

    }

    onAfterSave() {

    }

    async showPopup(data: any = {}) {
        this.isShow = true;
        this.openPopupDelete = false;
        await this.onShowPopup(data);

        setTimeout(() => {
            const viewRef = document.getElementById(this.popupId);
            if (viewRef != null) {
                const input = viewRef.querySelector('input');
                if (input) {
                    input.focus();
                } else {
                    const texateara = viewRef.querySelector('textarea');

                    if (texateara) {
                        texateara.focus();
                    }
                }
            }

            if (this.dialog) {
                this.dialog.center();
            }
        }, 500);
    }

    onShowPopup(data: any) {
        this.onReset();

        this.onBeforeShowPopUp();

        if (data > 0) {
            this._baseService.getDetail(data)
                .then(async response => {

                    this.itemDetail = response.data;
                    this.onAfterShowPopUp();

                }, error => {
                    this._notifierService.showHttpUnknowError();
                });
        }
    }

    onReset() {
        this.itemDetail = {};
    }

    onAfterShowPopUp() {

    }

    onBeforeShowPopUp() {

    }

    closePopupMethod(data: any) {
        this.isShow = false;
        this.closePopup.next(data);
    }

    getMaxWidthDialog() {
        return (window.innerHeight - 200).toString() + 'px';
    }

    onInsert() {
        this._baseService.post(this.itemDetail)
            .then(response => {
                this.closePopupMethod(true);
                this._notifierService.showInsertDataSuccess();
                this.onAfterSave();
                this.submitting = false;
            }, error => {
                this._notifierService.showInsertDataFailed();
                this.submitting = false;
            });
    }

    onUpdate() {
        this._baseService.put(this.itemDetail['id'].toString(), this.itemDetail)
            .then(response => {
                this.closePopupMethod(true);
                this._notifierService.showUpdateDataSuccess();
                this.onAfterSave();
                this.submitting = false;
            }, error => {
                this._notifierService.showUpdateDataFailed();
                this.submitting = false;
            });
    }

    cancel() {
        this.closePopupMethod(null);
    }

    buildFormGroup(formGroup?: FormGroup, formSchema?: FormSchemaItem[]) {
        const formGroupD = formGroup || this.formGroup;
        const formSchemaD = formSchema || this.formSchema;
        for (let i = 0; i < formSchemaD.length; i++) {
            const schemaItem = formSchemaD[i];
            const formControl = new FormControl('');
            if (schemaItem.control && schemaItem.control.defaultValue !== undefined) {
                this.itemDetail[schemaItem.field] = schemaItem.control.defaultValue;
                if (!schemaItem.visible && schemaItem.control.defaultValue) {
                    formControl.setValue(schemaItem.control.defaultValue);
                }
            }

            if (schemaItem.validators && schemaItem.validators.required) {
                formControl.setValidators(Validators.required);
            }

            formGroupD.addControl(schemaItem.field, formControl);
        }
    }

    resetForm() {
        if (this.validationSummary) {
            this.validationSummary.resetErrorMessages();
        }

        if (this.pUpload) {
            this.pUpload.clear();
        }

        this.formGroup.reset();
        this.itemDetail = {};
        this.uploadedFiles = [];
        this.submitting = false;
    }

    delete(id: number) {
        this._notifierService.showDeleteConfirm().then(rs => {
            this._baseService.delete(id)
                .then(response => {
                    this.closePopupMethod({});
                    this._notifierService.showDeleteDataSuccess();
                }, error => {
                    this._notifierService.showDeleteDataError();
                });
        });
    }

    scrollToTop() {
        if (this.formElement) {
            setTimeout(() => {
                this.formElement.nativeElement.scrollIntoView();
            }, 500);
        }
    }

    isValid(submitting = true) {
        if (this.formGroup.invalid) {
            this.validationSummary.showValidationSummary();
            this.submitting = false;
            return;
        }
        this.validationSummary.resetErrorMessages();
        return this.formGroup.valid;
    }

    togglePopupDelete() {
        this.openPopupDelete = !this.openPopupDelete;
    }
    resetDialogPosition() {
        window.setTimeout(() => {
            this.dialog.center();
        });
    }
    getMaxDialogHeight() {
        return (window.innerHeight - 200).toString() + 'px';
    }
    handleTabChange(event) {
        this.resetDialogPosition();
    }

    convertDataToOptions(options: any[], data: any[], fieldName: string) {
        if (data.length > 0) {
            data.map(item =>
                options.push({ label: item[fieldName], value: item.id })
            );
        }
    }

    mapJsonToDetailAddress(data: any): DetailAddress {
        return {
            place_id: data.place_id,
            licence: data.licence,
            osm_type: data.osm_type,
            osm_id: data.osm_id,
            lat: data.lat,
            lon: data.lon,
            class: data.class,
            type: data.type,
            place_rank: data.place_rank,
            importance: data.importance,
            addresstype: data.addresstype,
            name: data.name,
            display_name: data.display_name,
            address: {
                road: data.address.road,
                quarter: data.address.quarter,
                suburb: data.address.suburb,
                city: data.address.city,
                ISO3166_2_lvl4: data.address.ISO3166_2_lvl4,
                postcode: data.address.postcode,
                country: data.address.country,
                country_code: data.address.country_code
            },
            boundingbox: data.boundingbox
        };
    }

    buildTree(data: any, parentId = null) {
        const result = [];
        // Nếu parentId là null, ta sẽ tìm tất cả các mục có idParent là 0 (thằng cha to nhất)
        //const filteredData = parentId === null ? data.filter(item => item.idParent === 0) : data.filter(item => item.idParent === parentId);
        data
            .filter(item => item.idParent === parentId)
            .forEach(item => {
                const children = this.buildTree(data, item.id);
                const newNode = {
                    idParent: item.idParent,
                    id: item.id,
                    name: item.name,
                    checked: false,
                    expanded: false,
                    children: children.length ? children : undefined
                };
                result.push(newNode);
            });

        return result;
    }


    flattenTree(nodes: any[], level: number = 0): any[] {
        let result = [];
        nodes.forEach(node => {
            result.push({
                label: `${' _  '.repeat(level)} ${node.name}`,
                value: node.id
            });
            if (node.children) {
                result = result.concat(this.flattenTree(node.children, level + 1));
            }
        });
        return result;
    }

    generateTimeList(startH: number, startM: number, endH: number, endM: number, step: number) {
        const times = [];
        let hour = startH;
        let minute = startM;

        while (hour < endH || (hour === endH && minute <= endM)) {

            if (hour === 24 && minute > 0) break; // tránh 24:30

            const hh = hour.toString().padStart(2, '0');
            const mm = minute.toString().padStart(2, '0');

            times.push({ label: `${hh}:${mm}`, value: `${hh}:${mm}` });

            minute += step;
            if (minute >= 60) {
                minute = 0;
                hour++;
            }
        }
        return times;
    }
}
